export const EVENT_NAMES = {
    TAP_ANSWERED_WEB: 'tap_answered_web',
    TAP_LEAVE_TEST_POPUP_WEB: 'tap_leave_test_popup_web',
    TAP_LANGUAGE_TEST_START_WEB: 'tap_language_test_start_web',
    TAP_LANGUAGE_INSTRUCTION_WEB: 'tap_language_instruction_web',
    TAP_END_TEST_WEB: 'tap_end_test_web',
    TAP_LANGUAGE_QUESTIONS_WEB: 'tap_language_questions_web',
    TAP_REVIEW_WEB: 'tap_review_web',
    TAP_RESET_WEB: 'tap_reset_web',
    TAP_NEXT_WEB: 'tap_next_web',
    TAP_QUESTN_NAVGN_GRID_WEB: 'tap_questn_navgn_grid_web',
    TAP_PREVIOUS_WEB: 'tap_previous_web',
    TAP_SUBMIT_SUMMARY_SCREEN_WEB: 'tap_submit_summary_screen_web',
    POST_LOAD_SCREEN_WEB: 'post_load_screen_web',
    TAP_RESUME_SUMMAY_SCREEN_WEB: 'tap_resume_summay_screen_web',
    TAP_RESUME_TEST_WEB: 'tap_resume_test_web',
    TAP_START_TEST_WEB: 'tap_start_test_web',
    INSTRUCTION_LANDING_WEB: 'instruction_landing_web',
    TAP_DOWNLOAD_PDF_WEB: 'tap_download_pdf_web',
    TAP_SAMPLE_DOWNLOAD_PDF_WEB: 'tap_sample_download_pdf_web',
    TEST_RESULT_WEB: 'test_result_web',
    PRE_LOAD_SCREEN_WEB: 'pre_load_screen_web',
    LANDING_SCREEN_TEST_WEB: 'landing_screen_test_web',
    TAP_SECTION_WEB: 'tap_section_web',

    TESTPLAYER_SESSION_START: 'TestPlayer_session_start',
    TESTPLAYER_LANGUAGE_SELECTION: 'TestPlayer_language_selection',
    TESTPLAYER_START_TEST: 'TestPlayer_start_test',
    TESTPLAYER_SUBMIT_TEST: 'TestPlayer_submit_test',
    TESTPLAYER_AUTO_SUBMIT_TEST: 'TestPlayer_auto_submit_test',
}
